/* INTEGY V233 — desktop product page speed and instant photo enlargement — 11JUN2026 */
(function () {
  'use strict';
  if (window.INTEGY_V233_SPEED_PHOTOZOOM_LOADED) return;
  window.INTEGY_V233_SPEED_PHOTOZOOM_LOADED = true;

  function mq(q) { try { return window.matchMedia && window.matchMedia(q).matches; } catch (e) { return false; } }
  var desktop = mq('(min-width: 861px)');
  if (!desktop) return;
  document.documentElement.classList.add('integy-v233-speed-photozoom');

  function qs(sel, root) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }
  function qsa(sel, root) { try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; } }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  var warmed = Object.create(null);
  function cleanUrl(url) { return String(url || '').replace(/&amp;/g, '&'); }
  function currentSrc(img) { return cleanUrl(img && (img.currentSrc || img.getAttribute('src') || img.src || img.getAttribute('data-src') || '')); }
  function highSrc(img) { return cleanUrl(img && (img.getAttribute('data-photoswipe-src') || img.getAttribute('data-zoom') || currentSrc(img))); }
  function warm(url, priority) {
    url = cleanUrl(url);
    if (!url || warmed[url]) return;
    warmed[url] = 1;
    try {
      var im = new Image();
      im.decoding = 'async';
      if ('fetchPriority' in im) im.fetchPriority = priority ? 'high' : 'low';
      im.src = url;
    } catch (e) {}
  }

  function galleryFor(el) {
    return closest(el, 'product-gallery,.product-gallery') || qs('product-gallery,.product-gallery');
  }

  function galleryImages(gallery) {
    var imgs = qsa('.product-gallery__viewer img[data-photoswipe-src], .product-gallery__viewer img[data-zoom], .product-gallery__viewer img.media__image', gallery);
    if (!imgs.length) imgs = qsa('img[data-photoswipe-src],img[data-zoom],img.media__image', gallery);
    var seen = Object.create(null);
    return imgs.map(function (img) {
      var low = currentSrc(img);
      var high = highSrc(img);
      var key = high || low;
      if (!key || seen[key]) return null;
      seen[key] = 1;
      return { low: low, high: high, alt: img.getAttribute('alt') || '' };
    }).filter(Boolean);
  }

  function indexForTarget(target, gallery, items) {
    var slide = closest(target, '.swiper-slide');
    var img = qs('img[data-photoswipe-src],img[data-zoom],img.media__image,img', slide || closest(target, '.media') || target);
    var high = highSrc(img), low = currentSrc(img);
    for (var i = 0; i < items.length; i++) {
      if ((high && items[i].high === high) || (low && items[i].low === low)) return i;
    }
    var active = qsa('.product-gallery__navigation .swiper-slide-thumb-active,.product-gallery__navigation .integy-v231-thumb-active', gallery)[0];
    if (active) {
      var thumbs = qsa('.product-gallery__navigation .swiper-slide', gallery);
      var ix = thumbs.indexOf(active);
      if (ix >= 0 && ix < items.length) return ix;
    }
    return 0;
  }

  var overlay, state = { items: [], index: 0 };

  function buildOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'integy-v233-lightbox';
    overlay.hidden = true;
    overlay.innerHTML = '<div class="integy-v233-lightbox__top"><div class="integy-v233-lightbox__status"></div><button type="button" class="integy-v233-lightbox__close" aria-label="Close">×</button></div><div class="integy-v233-lightbox__stage"><button type="button" class="integy-v233-lightbox__prev" aria-label="Previous image">‹</button><img class="integy-v233-lightbox__img" alt=""><button type="button" class="integy-v233-lightbox__next" aria-label="Next image">›</button></div><div class="integy-v233-lightbox__thumbs" aria-label="Product images"></div>';
    document.body.appendChild(overlay);
    qs('.integy-v233-lightbox__close', overlay).addEventListener('click', closeOverlay);
    qs('.integy-v233-lightbox__prev', overlay).addEventListener('click', function () { show(state.index - 1); });
    qs('.integy-v233-lightbox__next', overlay).addEventListener('click', function () { show(state.index + 1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function (e) {
      if (!overlay || overlay.hidden) return;
      if (e.key === 'Escape') closeOverlay();
      if (e.key === 'ArrowLeft') show(state.index - 1);
      if (e.key === 'ArrowRight') show(state.index + 1);
    });
    return overlay;
  }

  function closeOverlay() {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  function renderThumbs() {
    var wrap = qs('.integy-v233-lightbox__thumbs', overlay);
    if (!wrap) return;
    wrap.innerHTML = '';
    state.items.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'integy-v233-lightbox__thumb' + (i === state.index ? ' is-active' : '');
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      b.innerHTML = '<img alt="" loading="lazy">';
      var im = qs('img', b);
      im.src = it.low || it.high;
      b.addEventListener('click', function () { show(i); });
      wrap.appendChild(b);
    });
  }

  function show(index) {
    if (!state.items.length) return;
    if (index < 0) index = state.items.length - 1;
    if (index >= state.items.length) index = 0;
    state.index = index;
    var item = state.items[index];
    var img = qs('.integy-v233-lightbox__img', overlay);
    var status = qs('.integy-v233-lightbox__status', overlay);
    var low = item.low || item.high;
    var high = item.high || low;
    overlay.classList.add('is-loading');
    status.textContent = (index + 1) + ' / ' + state.items.length;
    img.alt = item.alt || '';
    if (low) img.src = low;
    if (high && high !== low) {
      var hi = new Image();
      hi.decoding = 'async';
      if ('fetchPriority' in hi) hi.fetchPriority = 'high';
      hi.onload = function () {
        img.src = high;
        overlay.classList.remove('is-loading');
      };
      hi.onerror = function () { overlay.classList.remove('is-loading'); };
      hi.src = high;
      warm(high, true);
    } else {
      overlay.classList.remove('is-loading');
      warm(high, true);
    }
    qsa('.integy-v233-lightbox__thumb', overlay).forEach(function (b, i) { b.classList.toggle('is-active', i === index); });
    var next = state.items[index + 1] || state.items[0];
    var prev = state.items[index - 1] || state.items[state.items.length - 1];
    if (next) warm(next.high || next.low, false);
    if (prev) warm(prev.high || prev.low, false);
  }

  function openFrom(target) {
    var gallery = galleryFor(target);
    var items = galleryImages(gallery);
    if (!items.length) return false;
    state.items = items;
    state.index = indexForTarget(target, gallery, items);
    buildOverlay();
    renderThumbs();
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    show(state.index);
    return true;
  }

  function isTrigger(target) {
    if (!target || !target.closest) return false;
    if (closest(target, '.modal--quickshop-full,[data-modal-container].modal--quickshop-full')) return false;
    return closest(target, '.media__lightbox-button,[data-photoswipe-trigger-for],.swiper-slide__inner--cursor-pointer--always,.swiper-slide__inner--cursor-pointer--desktop,img.photoswipe__image');
  }

  ['pointerenter','focusin'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = isTrigger(e.target);
      if (!t) return;
      var g = galleryFor(t), items = galleryImages(g), ix = indexForTarget(t, g, items);
      if (items[ix]) warm(items[ix].high || items[ix].low, false);
    }, true);
  });

  document.addEventListener('pointerdown', function (e) {
    var t = isTrigger(e.target);
    if (!t) return;
    var g = galleryFor(t), items = galleryImages(g), ix = indexForTarget(t, g, items);
    if (items[ix]) warm(items[ix].high || items[ix].low, true);
  }, true);

  document.addEventListener('click', function (e) {
    var t = isTrigger(e.target);
    if (!t) return;
    if (openFrom(t)) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return false;
    }
  }, true);

  function warmInitialGallery() {
    var g = qs('product-gallery,.product-gallery');
    if (!g || closest(g, '.modal--quickshop-full')) return;
    var items = galleryImages(g);
    items.slice(0, 4).forEach(function (it, i) {
      setTimeout(function () { warm(it.high || it.low, i === 0); }, i * 120);
    });
  }

  function boot() {
    if ('requestIdleCallback' in window) requestIdleCallback(warmInitialGallery, { timeout: 1500 });
    else setTimeout(warmInitialGallery, 900);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('pageshow', function () { setTimeout(boot, 0); }, { passive: true });
})();
